export class DtoCoordenadas {
    X: string = '';
    Y: string = '';
}